(function () {
  function isReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initLenis() {
    if (typeof Lenis === 'undefined') return;
    if (window.__lenis) return;
    if (isReducedMotion()) return;

    var lenis = new Lenis({
      duration: 1.2,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      syncTouch: false,
      touchMultiplier: 2,
      wheelMultiplier: 1
    });

    if (typeof gsap !== 'undefined' && gsap.ticker) {
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
    }

    window.__lenis = lenis;

    // Route in-page anchor clicks through Lenis for a smooth jump
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var hash = link.getAttribute('href');
      if (!hash || hash === '#' || hash.length < 2) return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -20 });
    });
  }

  document.addEventListener('proart:loaded', initLenis);

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () { if (!window.__lenis) initLenis(); }, 100);
  });
})();
